"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MobileNav = exports.DEFAULT_CHAT_LINK = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const MobileNav_module_css_1 = __importDefault(require("./MobileNav.module.css"));
const MobileNavItem_1 = require("./MobileNavItem");
const content_1 = require("../../../content");
const react_intl_1 = require("react-intl");
const LocalizationWrapper_1 = require("../../LocalizationWrapper");
exports.DEFAULT_CHAT_LINK = "https://web.snapchat.com/?ref=web_nav_chat_icon";
/**
 *
 */
function MobileNav({ currentApp, onNavItemClick, chatIconOneLinkUrl }) {
    const intl = (0, react_intl_1.useIntl)();
    const chatIconLink = chatIconOneLinkUrl || exports.DEFAULT_CHAT_LINK;
    return ((0, jsx_runtime_1.jsx)("nav", { className: MobileNav_module_css_1.default.nav, "aria-label": intl.formatMessage({
            id: "CxMU6U",
            defaultMessage: "Mobile navigation widget",
            description: "Mobile navigation widget Aria Label",
        }), children: (0, jsx_runtime_1.jsx)("ul", { className: MobileNav_module_css_1.default.linkList, children: (0, content_1.getMobileNavV2Items)(intl, chatIconLink).map((item) => ((0, jsx_runtime_1.jsx)("li", { className: MobileNav_module_css_1.default.item, children: (0, jsx_runtime_1.jsx)(MobileNavItem_1.MobileNavItem, { item: item, active: item.id === currentApp, onClick: onNavItemClick }) }, item.id))) }) }));
}
/**
 * Localization Wrapper component for Mobile V2 Navigation
 */
function MobileNavWrapper(props) {
    const { locale, messages, ...restProps } = props;
    return ((0, jsx_runtime_1.jsx)(LocalizationWrapper_1.LocalizationWrapper, { locale: locale, messages: messages, children: (0, jsx_runtime_1.jsx)(MobileNav, { ...restProps }) }));
}
exports.MobileNav = MobileNavWrapper;
//# sourceMappingURL=MobileNav.js.map